import { render, staticRenderFns } from "./-BillingDetailsForm.vue?vue&type=template&id=fbc9bd76"
import script from "./-BillingDetailsForm.vue?vue&type=script&lang=js"
export * from "./-BillingDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports